import React, {useEffect} from 'react'
import {UserInfo} from "./useAuth"

type TokenStorage = {
    accessToken: string | undefined,
    idToken: string | undefined,
    expiresAt: any | number | bigint | undefined,
    registeredUser: boolean
    userinfo: UserInfo | null | undefined
}
export default function useStorage(initialValue: any, key: string): [TokenStorage, (v: TokenStorage | null) => void] {

    let v
    try {
        const stored = localStorage.getItem(key)
        v = stored ? JSON.parse(stored) : initialValue
    } catch (e) {
        v = initialValue
    }
    const [state, setState] = React.useState(v)

    React.useEffect(() => {
        localStorage.setItem(key, JSON.stringify(state))
    }, [state, key])

    useEffect(() => {
        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === key) {
                let v
                try {
                    v = e.newValue ? JSON.parse(e.newValue) : initialValue
                } catch (e) {
                    v = initialValue
                }
                setState(v);
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, [key])
    return [state, setState]
}
